import { errorMessage } from "../../utils/ErrorMessages";
import Repository from "../../services/repositories/RepositoryFactory";

const address = Repository.service("address");

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async verifyStopByAccount({ rootGetters }, id) {
      try {
        const response = await address.verifyStopByAccount(id);
        return response;
      } catch (error) {
        return errorMessage(error.response.data.detail.errors[0][rootGetters.getLanguage]);
      }
    },
  },
};
